import { render, staticRenderFns } from "./DesktopMainSubnavigationWithIcons.vue?vue&type=template&id=0de8e506&scoped=true&"
import script from "./DesktopMainSubnavigationWithIcons.vue?vue&type=script&lang=js&"
export * from "./DesktopMainSubnavigationWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMainSubnavigationWithIcons.vue?vue&type=style&index=0&id=0de8e506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de8e506",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCollection: require('/vercel/path0/components/general/IconCollection.vue').default,NavLink: require('/vercel/path0/components/navigation/NavLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
